/* ===========================================================================
   JD Gourmét — olive watermark: curve pour-colour propagation
   The curved transition at the top of each .jd-seam-top section reproduces the
   SECTION ABOVE so the two read as one continuous surface split by a curve. CSS
   can't read a previous sibling's colour, so we set --jd-pour-color here.

   We set it to the upper section's FILL VALUE (its scheme colour at the right
   alpha) — NOT its already-composited backgroundColor. The CSS then composites
   that value over the SAME fixed olive the upper section sits on, so a see-through
   upper band reproduces exactly (same tint AND same olive), leaving no seam.

   Gated: only runs when body.jd-watermark-on. Idempotent; re-runs on theme-editor
   section events and (debounced) resize. No deps.
   ========================================================================== */
(function () {
  'use strict';

  function schemeDiv(sectionEl) {
    return (
      sectionEl.querySelector(':scope > [class*="color-scheme"]') ||
      sectionEl.querySelector('[class*="color-scheme"]') ||
      sectionEl
    );
  }

  function apply() {
    if (!document.body.classList.contains('jd-watermark-on')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;

    main.querySelectorAll(':scope > .shopify-section').forEach(function (section) {
      var seam = section.querySelector(':scope > .jd-seam-top');
      if (!seam) return;

      var prev = section.previousElementSibling;

      // Walk past DORMANT sections that render nothing (e.g. jd-judgeme-reviews on
      // the PDP until the reviews app installs — Shopify still emits its empty
      // .shopify-section wrapper). Left un-skipped, the seam would pour from a
      // colourless neighbour → no curve, just a flat line at the boundary.
      while (prev && prev.offsetHeight === 0) {
        prev = prev.previousElementSibling;
      }

      // First content band sits under the opaque LCP hero — no pour. Clearing the
      // property lets ::after fall back to this band's own fill (clean top edge).
      if (!prev || prev.matches('.jd-hero-section') || prev.querySelector('.jd-hero-section')) {
        seam.style.removeProperty('--jd-pour-color');
        return;
      }

      var div = schemeDiv(prev);
      var cs = getComputedStyle(div);
      // The scheme's RGB triple (e.g. "245, 240, 235") — always resolvable.
      var triple = (cs.getPropertyValue('--color-background') || '').trim();

      var color;
      if (triple) {
        // Translucent (olive shows through) when the section is an even child and
        // not the hero — same condition as the CSS parity rule.
        var nth = Array.prototype.indexOf.call(prev.parentNode.children, prev) + 1;
        var translucent = nth % 2 === 0;
        color = translucent ? 'rgba(' + triple + ', 0.85)' : 'rgb(' + triple + ')';
      } else {
        // Fallback: a section with no scheme variable — use its rendered colour.
        color = cs.backgroundColor;
      }

      if (!color || color === 'rgba(0, 0, 0, 0)' || color === 'transparent') {
        seam.style.removeProperty('--jd-pour-color');
      } else {
        seam.style.setProperty('--jd-pour-color', color);
      }
    });

    measureFooter(main);
  }

  // The last email-capture band's ::before paints one continuous burgundy-over-olive
  // layer down through the footer (CSS §"Footer seam"). That pseudo is absolutely
  // positioned, so it must stop EXACTLY at the footer's bottom — any overshoot adds
  // empty scrollable space below the footer. Measure the real gap and write it.
  function measureFooter(main) {
    var lastSection = main.querySelector(':scope > .shopify-section:last-child');
    // Must mirror the CSS selector exactly: the continuous layer only engages for a
    // scheme-3 (burgundy) email-capture, because it stands in for the scheme-3
    // footer's own background. Measuring for any other scheme would publish a
    // --jd-footer-h that nothing paints.
    var ec = lastSection && lastSection.querySelector(':scope > .jd-email-capture.color-scheme-3');
    var footer = document.querySelector('.footer');
    if (!ec || !footer) return;
    var extend = Math.ceil(
      footer.getBoundingClientRect().bottom - ec.getBoundingClientRect().bottom
    );
    if (extend > 0) ec.style.setProperty('--jd-footer-h', extend + 'px');
    else ec.style.removeProperty('--jd-footer-h');
  }

  function debounced() {
    clearTimeout(apply._t);
    apply._t = setTimeout(apply, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  document.addEventListener('shopify:section:load', debounced);
  document.addEventListener('shopify:section:unload', debounced);
  document.addEventListener('shopify:section:reorder', debounced);
  window.addEventListener('resize', debounced);
  // Footer height isn't final until fonts/images settle — recompute after full load.
  window.addEventListener('load', debounced);

  window.JD = window.JD || {};
  window.JD.refreshPour = apply;
})();
